import { brandIdentity } from "./brand";

export const seoConfig = {
  siteName: brandIdentity.name,
  baseUrl: brandIdentity.baseUrl,
  defaultTitle: "TechniaHQRobot Humanoid Robots and Physical AI News",
  defaultDescription: brandIdentity.seoDescription,
  defaultImage: `${brandIdentity.baseUrl}/og-image-tech-ai-2025.png`,
  twitterHandle: brandIdentity.handle,
  email: brandIdentity.email,
};
